import { cn } from '@/lib/utils';
import { Loader2Icon } from 'lucide-react';

type SpinnerProps = React.ComponentProps<'svg'> & {
  /**
   * Keeps the spin under reduced motion. Pass it only where the spin is the
   * sole visible sign that work is in progress: no text beside it, a label
   * that stays the same while busy, or a label that folds into the icon in a
   * narrow container. See DESIGN.md, Motion.
   */
  readonly essential?: boolean;
};

function Spinner({ className, essential = false, ...props }: SpinnerProps) {
  return (
    <Loader2Icon
      role="status"
      aria-label="Loading"
      data-motion={essential ? 'essential' : undefined}
      className={cn('size-4 animate-spin', className)}
      {...props}
    />
  );
}

export { Spinner };
